import constants from '../constants/common';

const getCurrentItemSize = (items) => (items.length ? items[0].size : constants.AUTO_SIZE);

export default getCurrentItemSize;
